import { KnownMediums } from '../users/medium';

export interface IShareScreenDeepLinkParameters {
  workoutDuration?: string;
  fullname?: string;
  workoutDate?: string;
  level?: string;
  gender?: string;
  cardioOrResistance?: string;
  bodyGroups?: string;
  navigateToWorkoutStats?: string;
  calories?: string;
  effortPoints?: string;
  effortPercentage?: string;
}

export interface IWorkoutInvitationDeepLinkParameters {
  planId?: string;
  accountType?: string;
  landingPage?: string;
  workoutInviteId?: string;
  referredByUserId?: string;
  referredByFullname?: string;
  workoutInviteDuration?: string;
  workoutInviteStartTime?: string;
  influencerId?: string;
  medium?: string;
}

export interface IUpgradeAccountDeepLinkParameters {
  last_name?: string;
  email?: string;
  stripe_user_id?: string;
  stripe_source_id?: string;
  stripe_customer_id?: string;
  first_name?: string;
  onboarding?: string;
  pendingPlanId?: string;
  pendingCoupon?: string;
  coupon?: string;
  planId?: string;
  // errorMessage is deprecated 2023-05-17. Instead use statusMessage && statusMessageType
  errorMessage?: string;
  onceoff?: string;
}

export interface IFamilyMemberJoinInvitation {
  invitationCode?: string;
  referredByFullName?: string;
}

export interface IDemoStudioWorkoutSignup {
  email?: string;
  gymName?: string;
  firstname?: string;
  lastname?: string;
  mobileNumber?: string;
  continueSignupToken?: string;
  utm_medium: KnownMediums;
}

export enum deepLinkRouteParamOptions {
  subscription = 'subscription',
  installApp = 'install-app',
  billingInfo = 'billing-info',
  demoStudioWorkoutBooking = 'demo-studio-workout-booking',
  bodyScan = 'bodyscan',
}

export type StatusMessageType = 'error' | 'info' | 'warning';

export interface ISpecialOfferParams {
  userId?: string;
  specialOfferId?: string;
  billingStartDate?: string;
}

export interface IOauthParams {
  oauthToken: string,
  oauthVerifier: string,
}

export interface IDeeplinkParameters extends IShareScreenDeepLinkParameters,
  IUpgradeAccountDeepLinkParameters,
  IWorkoutInvitationDeepLinkParameters,
  IFamilyMemberJoinInvitation,
  IDemoStudioWorkoutSignup,
  ISpecialOfferParams {
  route?: deepLinkRouteParamOptions;
  statusMessage?: string;
  statusMessageType?: StatusMessageType;
  garminAuth?: IOauthParams;
}
